import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useTheme } from '@mui/material/styles';
import { useAuth } from "../../../hooks/useAuth";

const MobileTempPage = () => {
  const theme = useTheme();
  const auth = useAuth();

  const handleGoHome = () => {
    window.location.href = 'https://s-prodis.co.kr/';
  };

  const handleExit = () => {
    auth.logout();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        p: 3,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#f4f6f8',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          borderRadius: '12px',
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        <ConstructionIcon sx={{ fontSize: 60, color: theme.palette.primary.main, mb: 1 }} />
        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
          모바일 페이지를 준비 중입니다
        </Typography>
        <Typography variant="body1" color="text.secondary">
          현재 모바일 환경에 최적화된 페이지를 준비하고 있습니다.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          PC 환경에서는 모든 기능을 정상적으로 이용하실 수 있습니다.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button variant="contained" color="primary" onClick={handleGoHome}>
            홈페이지
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleExit}>
            나가기
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default MobileTempPage;
